<template>
    <label>
        <input type="number" :value="value" @input.capture="emitInput">
    </label>
</template>

<script>
export default {
    props: {
        value: {
            // Not restricting value type here to support integer custom fields are saved as string value in api
            default: "",
        }
    },
    methods: {
        emitInput: function (event) {
            this.$emit('input', parseInt(event.target.value))
        }
    },
}
</script>

<style scoped>
input {
    width: 100%;
}
</style>
